var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CustomTags',{attrs:{"tags":_vm.tagsWithoutDuplicates,"conditions":'from_collections',"defaultSearchText":_vm.tagFromCollection,"infos":_vm.$t('articles.no_tag_found_in_collections')}})
}
var staticRenderFns = []

export { render, staticRenderFns }